import { getSmoothStepPath, BaseEdge } from '@xyflow/react';

export const FlowEdge = ({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data }) => {
  const isHorizontal = Math.abs(sourceY - targetY) < 50;

  let edgePath;

  if (isHorizontal) {
    edgePath = `M ${sourceX} ${sourceY} L ${targetX} ${targetY}`;
  } else {
    [edgePath] = getSmoothStepPath({
      sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, borderRadius: 16,
    });
  }

  const statusColor = data?.status === 'active' ? '#3b82f6' : data?.status === 'reduced' ? '#eab308' : '#9ca3af';

  // Midpoint for tooltip positioning
  const midX = (sourceX + targetX) / 2;
  const midY = (sourceY + targetY) / 2;

  const hasInfo = data?.flowRate || data?.material;

  return (
    <g className="group">
      {/* Invisible wide hit area for hover */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={20}
        className="edge-hit-area"
        style={{ pointerEvents: 'stroke' }}
      />
      <BaseEdge
        id={id}
        path={edgePath}
        style={{ stroke: statusColor, strokeWidth: 1.5, strokeOpacity: 0.2, pointerEvents: 'none' }}
      />
      <path
        d={edgePath}
        fill="none"
        stroke={statusColor}
        strokeWidth={1}
        strokeDasharray="6 8"
        strokeOpacity={0.35}
        className="animate-flow-dash"
        style={{ pointerEvents: 'none' }}
      />
      <circle r="2" fill={statusColor} opacity={0.4} style={{ pointerEvents: 'none' }}>
        <animateMotion dur="5s" repeatCount="indefinite" path={edgePath} />
      </circle>

      {/* Hover tooltip */}
      {hasInfo && (
        <foreignObject
          x={midX - 75}
          y={midY - 14}
          width={150}
          height={28}
          className="pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-150"
          style={{ overflow: 'visible' }}
        >
          <div className="flex items-center justify-center">
            <div className="bg-white/95 backdrop-blur-sm text-[10px] px-2 py-1 rounded-lg shadow-sm border border-border whitespace-nowrap text-center" style={{ fontVariantNumeric: 'tabular-nums' }}>
              {data.flowRate && <span className="font-semibold">{data.flowRate} t/h</span>}
              {data.flowRate && data.material && <span className="text-muted-foreground"> · </span>}
              {data.material && <span className="text-muted-foreground">{data.material}</span>}
            </div>
          </div>
        </foreignObject>
      )}
    </g>
  );
};
